import React from 'react';
import {LogoStyle} from './style';


const Logo=()=> {

    return (
        <LogoStyle>  
           <a href="/">Resa Obamwonyi</a>
        </LogoStyle>
        )
}


export default Logo;
